import { getNextRoute } from '@dvp/helpers/Route'

import basketStore from '@shared/store/basket'
import useBasket from '@shared/hooks/useBasket'

import { ROUTE_INDEX, ROUTE_NAME } from '@shared/config/constants'

export default [
  {
    beforeEnter: (to, _from, next) => {
      const { isStaticBasket } = useBasket()

      if (isStaticBasket.value) {
        next({
          name: getNextRoute(basketStore.basket),
          params: {
            lang: to.params.lang,
          },
        })
      } else {
        next()
      }
    },
    component: () => import('@shared/modules/Dvp/screens/ScreenEntry'),
    meta: {
      index: ROUTE_INDEX.ENTRY,
      secured: true,
      navigation: false,
      headerItems: {
        basket: false,
        menu: true,
      },
    },
    name: ROUTE_NAME.ENTRY,
    path: 'entry',
    props: route => ({
      personId: route.params.personId,
      fieldName: route.params.fieldName,
    }),
  },
]
